<script setup lang="ts">
import { Badge } from '@/components/ui/badge'
import { formatLabel } from '@/lib/utils'

defineProps<{ status: string }>()

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline'

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  pending: 'secondary',
  quoted: 'default',
  referred: 'secondary',
  declined: 'destructive',
  cpa_sent: 'outline',
  submitted: 'outline',
  accepted: 'default',
}

const STATUS_CLASS: Record<string, string> = {
  accepted: 'border-green-500 bg-green-50 text-green-700 dark:bg-green-950 dark:text-green-300',
  referred: 'border-yellow-400 bg-yellow-50 text-yellow-700 dark:bg-yellow-950 dark:text-yellow-300',
  submitted: 'border-blue-400 bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
}
</script>

<template>
  <Badge :variant="STATUS_VARIANT[status] ?? 'secondary'" :class="STATUS_CLASS[status]">
    {{ formatLabel(status) }}
  </Badge>
</template>
